import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const UsdCircle = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C18.1 23 23 18.1 23 12C23 5.9 18.1 1 12 1ZM11 11H13C14.7 11 16 12.3 16 14C16 15.7 14.7 17 13 17V18C13 18.6 12.6 19 12 19C11.4 19 11 18.6 11 18V17H9C8.4 17 8 16.6 8 16C8 15.4 8.4 15 9 15H13C13.6 15 14 14.6 14 14C14 13.4 13.6 13 13 13H11C9.3 13 8 11.7 8 10C8 8.3 9.3 7 11 7V6C11 5.4 11.4 5 12 5C12.6 5 13 5.4 13 6V7H15C15.6 7 16 7.4 16 8C16 8.6 15.6 9 15 9H11C10.4 9 10 9.4 10 10C10 10.6 10.4 11 11 11Z"
      fill="currentColor"
    />
  </svg>
)

export default UsdCircle
